import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariable } from 'app/global/global';

@Injectable({
  providedIn: 'root'
})
export class ServicioService {

  url: string = GlobalVariable.BASE_API_URL + "api/servicio/";

  constructor(private http: HttpClient) { }

  listar(especialidadId: number): Observable<any> {
    return this.http.get(this.url + "listar/" + especialidadId);
  }

  crear(form: any): Observable<any> {
    const formData = new FormData();
    formData.append("especialidad_id", form.especialidad_id.toString());
    formData.append("nombre", form.nombre.trim());
    formData.append("valor", form.valor.toString());
    formData.append("duracion", form.duracion);
    formData.append("porcentaje_reserva", form.porcentaje_reserva.toString());
    formData.append("descripcion", form.descripcion || '');
    return this.http.post(this.url + "crear", formData);
  }

  editar(form: any): Observable<any> {
    const formData = new FormData();
    formData.append("id", form.id.toString());
    formData.append("especialidad_id", form.especialidad_id.toString());
    formData.append("nombre", form.nombre.trim());
    formData.append("valor", form.valor.toString());
    formData.append("duracion", form.duracion);
    formData.append("porcentaje_reserva", form.porcentaje_reserva.toString());
    formData.append("descripcion", form.descripcion || '');
    return this.http.post(this.url + "editar", formData);
  }

  borrar(id: number): Observable<any> {
    return this.http.delete(this.url + "borrar/" + id);
  }

  mostrar(id: number): Observable<any> {
    return this.http.get(this.url + "mostrar/" + id);
  }
}
